module.exports = __webpack_public_path__ + "img/easy-pie-crust.8ce82043.jpg";